module.exports = require('./lodash');